import { Alert, AlertTitle, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { type IRealEstateReceptionBookImportStatusObject } from "../types";
import { format } from "date-fns";

interface Props {
  importStatuses: IRealEstateReceptionBookImportStatusObject[];
}

const ReceptionBookImportStatus: React.FC<Props> = ({ importStatuses }) => {
  return (
    <Alert severity="info">
      <AlertTitle sx={{ fontWeight: "bold" }}>更新情報</AlertTitle>
      <Box style={{ maxHeight: "6.5em", overflow: "auto" }}>
        <Grid container spacing={2}>
          {importStatuses.map((item) => (
            <Grid item key={item.prefecturesId}>
              ● {format(new Date(item.importDate), "yyyy/MM/dd")}
              <Typography sx={{ fontWeight: "bold", mx: 0.5 }} display="inline">
                {item.prefecturesName}
                {format(
                  new Date(item.legalAffairsBureauRequestMonth),
                  "yyyy/MM"
                )}
              </Typography>
              公開
            </Grid>
          ))}
        </Grid>
      </Box>
    </Alert>
  );
};

export { ReceptionBookImportStatus };
